import {
    SupportedBackOffices,
    ThirdPartyBackOfficeFields,
} from 'types/ThirdPartyBackOffice';

/** Mapping of supported backoffice products to the label/field names that are specific to that backoffice product. */
export const backofficeFields: Record<
    SupportedBackOffices,
    ThirdPartyBackOfficeFields
> = {
    cargas: {
        label: 'Cargas',
        account_number: 'Account Number',
        tank_number: 'Tank Number',
    },
    adds: {
        label: 'ADDs',
        account_number: 'Account Number',
        tank_number: 'Tank Number',
    },
    bluecow: {
        label: 'BlueCow',
        account_number: 'Customer Number',
        tank_number: 'Location Number',
    },
    fds: {
        label: 'RCC FDS',
        account_number: 'Location Number',
        tank_number: 'Account ID',
    },
    fuelpack: {
        label: 'RCC FuelPak',
        account_number: 'Account Number',
        tank_number: 'Location Number',
    },
    columbus: {
        label: 'Columbus',
        account_number: 'Account ID',
        tank_number: 'Tank Number',
    },
    drm: {
        label: 'DRM',
        account_number: 'Account ID',
        tank_number: 'Tank Number',
    },
    kkcomp: {
        label: 'EnergyForce',
        account_number: 'Customer Number',
        tank_number: 'Tank RNN',
    },
    suburban: {
        label: 'Suburban',
        account_number: 'Account Number',
        tank_number: 'Branch Number',
    },
    fuel_data_systems: {
        label: 'Fuel Data Systems',
        account_number: 'Account Number',
        tank_number: 'Location Number',
    },
    agvantage: {
        label: 'Agvantage',
        account_number: 'Customer Number',
        tank_number: 'Site Sequence',
    },
    red_river: {
        label: 'Red River',
        account_number: 'Customer Number',
        tank_number: 'Site Sequence',
    },
    skybitz: {
        label: 'Skybitz',
        account_number: 'Account Number',
        tank_number: 'Tank Number',
    },
    awe: {
        label: 'AWE',
        account_number: 'Account Number',
        tank_number: 'Tank Number',
    },
    efc: {
        label: 'EFC',
        account_number: 'Account ID',
        tank_number: 'Tank ID',
    },
    not_found: {
        label: 'Back Office',
        account_number: 'Account Number',
        tank_number: 'Tank Number',
    },
    '': {
        label: '',
        account_number: '',
        tank_number: '',
    },
    none: {
        label: '',
        account_number: '',
        tank_number: '',
    },
};

/** Individual backoffice dropdown menu option. */
export type BackofficeOption = {
    value: string;
    label: string;
};

/** Dropdown menu options for supported third-party backoffice products. */
export const backofficeOptions: BackofficeOption[] = [
    { value: 'none', label: 'None' },
    { value: 'adds', label: 'ADDs' },
    { value: 'bluecow', label: 'BlueCow' },
    { value: 'cargas', label: 'CarGas' },
    { value: 'drm', label: 'DRM' },
    { value: 'columbus', label: 'Columbus/Lynx' },
    { value: 'kkcomp', label: 'Energy Force' },
    { value: 'fuelpack', label: ' RCC - FuelPak' },
    { value: 'fds', label: 'RCC - FDS' },
    { value: 'suburban', label: 'Suburban' },
    { value: 'fuel_data_systems', label: 'Fuel Data Systems' },
    { value: 'agvantage', label: 'Agvantage' },
    { value: 'red_river', label: 'Red River' },
    { value: 'skybitz', label: 'SkyBitz' },
    { value: 'awe', label: 'AWE' },
    { value: 'taurus', label: 'Taurus' },
    { value: 'efc', label: 'EFC' },
];
